<template>
  <div style>
    <!-- 分类检索 -->
    <MTop title="门类检索（多选）" />
    <div style="padding:10px 20px;">
      <el-input class="tac" prefix-icon="el-icon-search" placeholder="搜索"></el-input>
    </div>
    <!-- <div style="padding:10px 20px;">
      <el-button v-if="!isShowInput" @click="addType">自定义+</el-button>
      <div v-if="isShowInput" style="display:flex;">
        <el-input v-model="value"></el-input>
        <el-button @click="submitType" type="primary" style="padding:5px 20px;margin-left:10px;">确定</el-button>
      </div>
    </div>-->
    <div class="type-list" style="background:#fff;">
      <el-checkbox-group @change="changeChecked" v-model="checkList">
        <ul>
          <li v-for="(item,index) in videoOneCate" :key="item.title">
            <el-checkbox :label="item.title">{{item.title}}</el-checkbox>
            <!-- <div v-if="item.id == -1" class="fr" style="width:20px;height:20px;">
              <i
                @click="cancelType(index)"
                style="font-size:16px;display:inline-block;width:100%;height:100%;"
                class="el-icon-circle-close"
              ></i>
            </div>-->
          </li>
        </ul>
      </el-checkbox-group>
    </div>
    <!-- 提交按钮 -->
    <div style="padding:20px;width:100%;">
      <el-button @click="submitSearchType" type="primary" style="width:100%;">确定</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MTop from "../../top/mtop";
import map from "../../../../static/json/district.json";

/**
 * 扩展Array方法, 去除数组中空白数据
 */
Array.prototype.notempty = function() {
  var arr = [];
  this.map(function(val, index) {
    //过滤规则为，不为空串、不为null、不为undefined，也可自行修改
    if (val !== "" && val != undefined) {
      arr.push(val);
    }
  });
  return arr;
};
// 给JS的数组对象定义一个函数，用于查找指定的元素在数组中的位置，即索引
Array.prototype.indexOf = function(val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == val) return i;
  }
  return -1;
};
// 然后使用通过得到这个元素的索引，使用js数组自己固有的函数去删除这个元素
Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
export default {
  components: {
    MTop
  },
  data: function() {
    return {
      isShowInput: false,
      value: "",
      checkList: Array,
      videoOneCate: [
        {
          id: 0,
          title: "新闻类",
          value: "NEWS"
        },
        {
          id: 1,
          title: "直播类",
          value: "LIVE"
        },
        {
          id: 2,
          title: "访谈类",
          value: "VIEW"
        },
        {
          id: 3,
          title: "作品",
          value: "WORKS"
        },
        {
          id: 4,
          title: "其他",
          value: "OTHER"
        }
      ]
    };
  },
  computed: mapState({
    videoTwoCate: "videoTwoCate"
  }),
  methods: {
    changeChecked: function() {
      // this.checkList= []
      var valueArr = [];
      // console.log("checkList:", this.checkList);
      this.videoOneCate.forEach(item => {
        this.checkList.forEach(item2 => {
          if (item.title == item2) {
            valueArr.push(item.value);
          }
        });
      });
      this.$store.state.videoOneValue = valueArr.join(",");
      // console.log(this.$store.state.videoOneValue)
    },
    //   自定义门类
    addType: function() {
      this.isShowInput = true;
    },
    submitType: function() {
      console.log(this.value);
      //   alert(this.videoTwoCate.indexOf({ title: this.value }));
      if (this.value) {
        try {
          this.videoTwoCate.forEach(item => {
            if (item.title == this.value) {
              //   alert(22);
              throw new Error("ending");
            }
          });
        } catch (e) {
          if (e.message == "ending") {
            this.$message.error("重复输入");
            return;
          }
        }

        // alert(1);
        var arr = { id: -1, title: this.value };
        this.videoTwoCate.unshift(arr);
      }
    },
    cancelType: function(index) {
      this.checkList.remove(this.videoTwoCate[index].title);
      this.videoTwoCate.splice(index, 1);

      // console.log(this.videoTwoCate)
      // console.log(this.videoTwoCate[index].title)
      // console.log('checkList:',this.checkList)
    },
    // 提交
    submitSearchType: function() {
      var str = this.checkList.join(",");
      console.log("str:", this.checkList);
      this.$store.commit("getClassType", str);
      this.$router.push({
        path: "/videolist2",
        query: {}
      });
    },
    // 找出自定义的门类
    selectAddType: function(a, b) {
      for (var i = 0; i < a.length; i++) {
        for (var j = 0; j < b.length; j++) {
          if (a[i] == b[j]) {
            b.splice(j, 1);
          }
        }
      }
      return b;
    }
    // 添加数组对象
    // addArrObj:function(far,son){
    //   son.forEach(item=>{
    //   far.unshift({id:-1,title:item})
    //   })
    //   return far
    // }
  },
  mounted: function() {
    // this.$store.dispatch("getTypeList");
    // this.$store.state.checkedOneList = ''
    console.log(this.$store.state.checkedOneList);
    var showList = this.$store.state.checkedOneList.split(",").notempty();
    this.checkList = this.$store.state.checkedOneList.split(",").notempty();
    var newArr = [];
    var addArr = [];
    this.videoOneCate.forEach(item1 => {
      newArr.push(item1.title);
    });
  }
};
</script>

<style scoped lang="scss">
.type-list {
  ul {
    li {
      padding: 10px 20px;
      border-bottom: 1px solid #dddddd;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/searchpage/type.vue